import { Injectable } from '@angular/core';
import { Role } from '../../Enums/Role';
import { AuthenticationService } from '../auth.service';
import { GenericService } from '../generic.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(private apiService: GenericService, private auth: AuthenticationService) { }

  getSubscriptionDetail() {
    return this.apiService.Get<any>(`company/subcripation-details`);
  }

  getCompanyList(permission?: any) {
    if (this.auth.currentUserValue.role == Role.SuperAdmin) {
      return this.apiService.Get<any>(`company/get-list`);
    } else {
      if (permission) return this.apiService.Get<any>(`company/get-list?permission=${permission}`);
      else return this.apiService.Get<any>(`company/get-list`);
    }
  }

  getCompangyListDms(permission: any) {
     return this.apiService.Get<any>(`company/get-list?permission=${permission}`);
    }
  

  getCompanyByPagination(model: any) {
    return this.apiService.Post<any>(`company/pagination`, model);
  }

  addUpdateCompany(model: any) {
    return this.apiService.Post<any>(`company/create-or-update`, model);
  }

  getCompanyById(id: any) {
    return this.apiService.Get<any>(`company/get-by-id/${id}`);
  }
  deleteCompany(id: any) {
    return this.apiService.Get<any>(`company/delete/${id}`);
  }

  getcompanybycategory(id){
    return this.apiService.Get<any>(`category/company?categoryId=${id}`);
  }
}
